import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getTableFooterStyles = () =>
    css({
        justifyContent: 'space-between',
    });

export const getTableEmptyStyles = (theme: Theme) =>
    css({
        textAlign: 'center',
        padding: `${theme.spacing(5)}px 0`,
    });

export const getFiltersStyles = (theme: Theme) =>
    css({
        marginBottom: theme.spacing(2),
    });

export const getDatePickerStyles = () =>
    css({
        minWidth: 260,
    });

export const getTableStyles = (isRefetching: boolean) => () =>
    css({
        opacity: isRefetching ? 0.6 : 1,
    });
